import { MockFactory } from '@tino-frontend/mocks'
import {
  BillInvoiceInstallmentsMopStatus,
  BillLineInstallmentStatus,
  InstallmentStatus,
  MerchantGetInvoiceResponse,
} from '@types'
import { lineItemInstallmentEdited } from '@fixtures/apis/bill/line-item/installment-edited'
import { lineItemInstallment } from '@fixtures/apis/bill/line-item/installment'

const installment1 = lineItemInstallment.build(
  {
    ...lineItemInstallment.source,
    id: 'line_item_id_01',
    amount_cents: 66666,
    metadata: {
      ...lineItemInstallment.source.metadata,
      installment_id: 'invoice_installments_id_1',
      versions: [
        {
          invoice_total_amount_cents: 20,
          invoice_num_installments: 2,
          installment_number: 1,
          installment_total_amount_cents: 20,
          installment_settlement_date: '2023-12-02T00:00:00Z',
          installment_estimated_due_date: '2023-12-02',
          installment_edited_at: '2023-12-06T00:00:00Z',
          installment_internal_status: BillLineInstallmentStatus.Open,
        },
        {
          invoice_total_amount_cents: 60,
          invoice_num_installments: 2,
          installment_number: 1,
          installment_total_amount_cents: 60,
          installment_settlement_date: '2023-12-02T00:00:00Z',
          installment_estimated_due_date: '2023-12-02',
          installment_edited_at: '2023-12-06T00:00:00Z',
          installment_internal_status: BillLineInstallmentStatus.Open,
        },
      ],
    },
  },
  { mergeArray: false }
)

const installment2Edited = lineItemInstallmentEdited.build(
  {
    ...lineItemInstallmentEdited.source,
    amount_cents: 77777,
    metadata: {
      ...lineItemInstallmentEdited.source.metadata,
      installment_id: 'invoice_installments_id_2',
      versions: [
        {
          invoice_total_amount_cents: 22,
          invoice_num_installments: 2,
          installment_edited_at: '2023-12-01T00:00:00Z',
          installment_number: 1,
          installment_total_amount_cents: 22,
          installment_settlement_date: '2023-12-01T00:00:00Z',
          installment_estimated_due_date: '2023-12-01',
          installment_internal_status: BillLineInstallmentStatus.Canceled,
        },
        {
          invoice_total_amount_cents: 77777,
          invoice_num_installments: 2,
          installment_number: 1,
          installment_total_amount_cents: 77777,
          installment_settlement_date: '2023-12-02T00:00:00Z',
          installment_estimated_due_date: '2023-12-02',
          installment_edited_at: '2023-12-06T00:00:00Z',
          installment_internal_status: BillLineInstallmentStatus.Open,
        },
      ],
    },
  },
  { mergeArray: false }
)

const installment3Edited = lineItemInstallmentEdited.build(
  {
    ...lineItemInstallmentEdited.source,
    amount_cents: 8888,
    metadata: {
      ...lineItemInstallmentEdited.source.metadata,
      installment_id: 'invoice_installments_id_3',
      versions: [
        {
          invoice_total_amount_cents: 23,
          invoice_num_installments: 2,
          installment_edited_at: '2023-12-01T00:00:00Z',
          installment_number: 1,
          installment_total_amount_cents: 23,
          installment_settlement_date: '2023-12-01T00:00:00Z',
          installment_estimated_due_date: '2023-12-01',
          installment_internal_status: BillLineInstallmentStatus.Canceled,
        },
        {
          invoice_total_amount_cents: 8888,
          invoice_num_installments: 2,
          installment_number: 1,
          installment_total_amount_cents: 8888,
          installment_settlement_date: '2023-12-02T00:00:00Z',
          installment_estimated_due_date: '2023-12-02',
          installment_edited_at: '2023-12-06T00:00:00Z',
          installment_internal_status: BillLineInstallmentStatus.Open,
        },
      ],
    },
  },
  { mergeArray: false }
)

export const listEditedMock = new MockFactory<MerchantGetInvoiceResponse>({
  invoice: {
    amount_cents: 200000,
    original_amount_cents: 199800,
    merchant_service_fee_amount_cents: 200,
    buyer_company_id: 'buyer_company_id_1',
    buyer_name: 'Buyer Company Ltda.',
    created_at: '2021-03-31T11:45:25.126666Z',
    deal_conditions: [10, 30, 60],
    description: 'Test 2',
    due_date: '2021-04-10T00:00:00Z',
    id: 'id_1',
    installments: 2,
    invoice_installments: [
      {
        transaction_id: 'transaction_id',
        amount_cents: 66666,
        buyer_conciliated_amount: 66661,
        buyer_conciliation_status: InstallmentStatus.FullySettled,
        id: 'invoice_installments_id_1',
        line_code: '34191.09107 52014.087309 71444.640008 1 93930000001200',
        mop_status: BillInvoiceInstallmentsMopStatus.Paid,
        settlement_date: '2023-06-29T00:00:00Z',
        status: InstallmentStatus.Confirmed,
        url: 'https://a.com',
      },
      {
        transaction_id: 'transaction_id',
        amount_cents: 77777,
        buyer_conciliated_amount: 77771,
        buyer_conciliation_status: InstallmentStatus.PartiallySettled,
        id: 'invoice_installments_id_2',
        line_code: '34191.09107 52014.087309 71444.640008 1 93930000001200',
        mop_status: BillInvoiceInstallmentsMopStatus.Paid,
        settlement_date: '2023-06-29T00:00:00Z',
        status: InstallmentStatus.Confirmed,
        url: 'https://a.com',
      },
      {
        transaction_id: 'transaction_id',
        amount_cents: 8888,
        buyer_conciliated_amount: 8881,
        buyer_conciliation_status: InstallmentStatus.Pending,
        id: 'invoice_installments_id_3',
        line_code: '34191.09107 52014.087309 71444.640008 1 93930000001200',
        mop_status: BillInvoiceInstallmentsMopStatus.Paid,
        settlement_date: '2023-06-29T00:00:00Z',
        status: InstallmentStatus.Confirmed,
        url: 'https://a.com',
      },
    ],
    seller_company_id: 'seller_company_id_1',
    seller_name: 'Marco Polo Ltda.',
    short_id: 'short_id_1',
    external_id: 'external_id_1',
    status: 'approved',
  },
  line_items: [installment1, installment2Edited, installment3Edited],
  nfe_download_token: 'nfe_download_token',
})
